"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function combineClassNames(classes) {
    return classes
        .map((c) => (c ? c.trim() : c))
        .filter((c) => c)
        .join(' ');
}
function createClassString(...classes) {
    const classNames = classes.length === 1 && Array.isArray(classes[0])
        ? classes[0]
        : classes;
    return combineClassNames(classNames);
}
exports.default = createClassString;
